// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"28c52567","84":"416ac439","349":"28c52567","424":"28c52567","525":"28c52567","543":"28c52567","660":"33291157","865":"28c52567","893":"3cbad5c7","948":"3cbad5c7","969":"28c52567"}[chunkId] + ".chunk.css";
};